import React from 'react';
import { FormControl, MenuItem, Select as MUISelect } from '@material-ui/core';
import { SelectOption } from 'models/forms';
import useStyles from './style';

interface Props {
  id: string;
  name: string;
  value: number | null;
  options: SelectOption[];
  onChange: (
    event: React.ChangeEvent<{
      name?: string | undefined;
      value: unknown;
    }>,
    child: React.ReactNode,
  ) => void;
}

const Select: React.FC<Props> = (props) => {
  const { id, name, value, options, onChange } = props;
  const classes = useStyles();
  let currentValue: unknown = value;

  if (!value) {
    if (options.length > 0) {
      currentValue = options[0].value;
    } else {
      currentValue = '';
    }
  }

  return (
    <FormControl className={classes.formControl} required>
      <MUISelect
        id={id}
        name={name}
        value={currentValue}
        onChange={onChange}
        className={classes.select}
        disableUnderline
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </MUISelect>
    </FormControl>
  );
};

export default Select;
